export default "__VITE_ASSET__X4opiZCn__"